<template>
<div>
  <DIV
    class="col-4"
    v-if="loaded"
  >
    <ItpFormInput
      mask="number"
      unmask="typed"
      :scale="scale"
      :name="name + '__amount'"
      v-model="internalValue.amount"
      :readonly="readonly"
      @input="evh_2248226175642056_input($event, {})"
    >
    </ItpFormInput>
  </DIV>
  <DIV
    class="col-3"
    v-if="loaded"
  >
    <CurrencySelector
      :name="name + '__currency'"
      :item="internalValue"
      path="currency"
      :readonly="readonly"
      @input="evh_96700093353179_input($event, {})"
    >
    </CurrencySelector>
  </DIV>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MonetaryAmountFieldset extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  name!: string;

  @Watch('name')
  onName(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("name")
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    required: true,
    type: String,
  })
  path!: string;

  @Watch('path')
  onPath(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("path")
  }

  @Prop({
    type: String,
  })
  defaultCurrency!: string;

  @Watch('defaultCurrency')
  onDefault_currency(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("defaultCurrency")
  }

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$app.repo.get('list_currency', { map: true, key: 'code' })
  }

  internalValue!: any;

  async $$load_internalValue() {
    return _.extend({
      amount: null,
      currency: this.defaultCurrency,
    }, this.item[this.path])
  }

  ux!: any;
  dataMembers = ['currencies', 'internalValue', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        currencies: null,
        internalValue: null,
        ux: null,
      },
    }
  }

  get scale() {
    if (this.loaded) {

      return this.internalValue.currency ? this.currencies[this.internalValue.currency].digits : null
    }
    return null;
  }

  get publicValue() {
    if (this.loaded) {

      return this.internalValue.currency && this.internalValue.amount != null ? this.internalValue : null
    }
    return null;
  }

  async act_2248226175642056_script_2918_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2248226175642056_script_2918, alias=undefined
    this.item[this.path] = this.publicValue
  }

  async act_2248226175642056_script_2918_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2248226175642056_script_2918, alias=undefined
    return {
      value: () => this.act_2248226175642056_script_2918_getActionArgs_value($event),
    }
  }

  async evh_2248226175642056_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_input.executeFromDOM(this, event, scope);
  }

  async act_96700093353179_script_2920_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_96700093353179_script_2920, alias=undefined
    this.item[this.path] = this.publicValue
  }

  async act_96700093353179_script_2920_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_96700093353179_script_2920, alias=undefined
    return {
      value: () => this.act_96700093353179_script_2920_getActionArgs_value($event),
    }
  }

  async evh_96700093353179_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_96700093353179_input.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_2248226175642056_script_2918: actions.ScriptAction;
    evh_2248226175642056_input_2917: actions.EventHandlerImpl;
    evh_2248226175642056_input: actions.EventHandlerGroup;
    act_96700093353179_script_2920: actions.ScriptAction;
    evh_96700093353179_input_2919: actions.EventHandlerImpl;
    evh_96700093353179_input: actions.EventHandlerGroup;
  }

  getActions() {
    const act_2248226175642056_script_2918 = new actions.ScriptAction(
      {
        actionArgs: this.act_2248226175642056_script_2918_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_input_2917 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_script_2918,
        event: "input",
        displayName: "script",
      }
    );
    const evh_2248226175642056_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_input_2917],
      }
    );
    const act_96700093353179_script_2920 = new actions.ScriptAction(
      {
        actionArgs: this.act_96700093353179_script_2920_getActionArgs,
        events: [],
      }
    );
    const evh_96700093353179_input_2919 = new actions.EventHandlerImpl(
      {
        action: act_96700093353179_script_2920,
        event: "input",
        displayName: "script",
      }
    );
    const evh_96700093353179_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_96700093353179_input_2919],
      }
    );
    return {
      act_2248226175642056_script_2918,
      evh_2248226175642056_input_2917,
      evh_2248226175642056_input,
      act_96700093353179_script_2920,
      evh_96700093353179_input_2919,
      evh_96700093353179_input,
    }
  }
}

Vue.component("MonetaryAmountFieldset", MonetaryAmountFieldset);

</script>